// extracted by mini-css-extract-plugin
export default {"ldio":"styles_ldio__DshR0","ldio-r":"styles_ldio-r__v2DkV","ldio-c":"styles_ldio-c__v822K","loadingSpinnerEllipsis":"styles_loadingSpinnerEllipsis__UJnfu"};